import { Game } from "../../../Game";



/**
 * Nastaveni kolizni oblasti prekazky
 */
export class ObstacleCollisionArea {
    get area(): pc.BoundingBox | pc.BoundingSphere { return this._area; }
    private _area: pc.BoundingBox | pc.BoundingSphere;

    get isBox(): boolean { return this._isBox; }
    private _isBox: boolean;

    constructor(area: pc.BoundingBox | pc.BoundingSphere) {
        this._area = area;
        this._isBox = area instanceof pc.BoundingBox;
    }
}



/**
 * Nastaveni falesneho stinu prekazky
 */
export class ObstacleShadow {
    /**
     * (RO) Jmeno klice snimku v atlasu
     */
    get frameKey(): string { return this._frameKey; }
    private _frameKey: string;

    /**
     * (RO) Offset entity se stinem na ose X
     */
    get offsetX(): number { return this._offsetX; }
    private _offsetX: number;

    /**
     * (RO) Offset entity se stinem na ose Y
     */
    get offsetY(): number { return this._offsetY; }
    private _offsetY: number;

    /**
     * (RO) Offset entity se stinem na ose Z
     */
    get offsetZ(): number { return this._offsetZ; }
    private _offsetZ: number;

    /**
     * (RO) Sirka stinu v metrech
     */
    get width(): number { return this._width; }
    private _width: number;

    /**
     * (RO) Hloubka stinu
     */
    get depth(): number { return this._depth; }
    private _depth: number;

    /**
     * (RO) True, pokud entita se stinem je child entinty s prekazkou. Pokud false, tak je stin child entity graphNode radky
     */
    get isLocal(): boolean { return this._isLocal; }
    private _isLocal: boolean;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(frameKey: string, width: number, depth: number, offsetX: number, offsetY: number, offsetZ: number, isLocal: boolean) {
        this._frameKey = frameKey;
        this._width = width;
        this._depth = depth;
        this._offsetX = offsetX;
        this._offsetY = offsetY;
        this._offsetZ = offsetZ;
        this._isLocal = isLocal;
    }
}



export class ObstacleAnimation {
    /**
     * (RO) Asset s animaci
     */
    get asset(): pc.Asset { return this._asset; }
    private _asset: pc.Asset;

    /**
     * (RO) True, pokud se ma animace prehravat ve smycce
     */
    get loop(): boolean { return this._loop; }
    private _loop: boolean;

    /**
     * (RO) Vzdalenost od hrace, kdy ma dojit k zahajeni prehravani animace
     */
    get actDistance(): number { return this._actDistance; }
    private _actDistance: number;

    //-------------------------------------------------------------------------
    /**
     * 
     * @param assetKey 
     * @param loop 
     * @param actDistance Vzdalenost od hrace, kdy ma dojit k zahajeni prehravani animace. Pokud <= 0, tak se animace zacne prehravat okamzite.
     */
    //-------------------------------------------------------------------------
    constructor(assetKey: string, loop: boolean, actDistance: number) {
        this._asset = Game.app.assets.find(assetKey, pc.ASSET_ANIMATION);
        this._loop = loop;
        this._actDistance = actDistance;
    }
}



export class ObstacleVersion {
    /**
     * (RO) Index verze v ramci typu
     */
    get id(): number { return this._id; }
    private _id: number;

    /**
     * (RO) Asset pro model prekazky
     */
    get modelAsset(): pc.Asset { return this._modelAsset; }
    private _modelAsset: pc.Asset;

    /**
     * (RO) Pozice prekazky na ose Y
     */
    get y(): number { return this._y; }
    private _y: number;

    /**
     * (RO) Kolizni oblast prekazky (bud box nebo sphere). Pozice stredu je offset od pozice prekazky v hernim svete
     */
    get colAreas(): ObstacleCollisionArea[] { return this._colAreas; }
    private _colAreas: ObstacleCollisionArea[];

    /**
     * (RO) Maximalni vzdalenost od hrace na jednotlivych osach, pri kterych bude testovana kolize "prekazka" VS "hrac". Vzdalenost se pocita od originu modelu prekazky.
     */
    get colDistance(): pc.Vec3 { return this._colDis; }
    private _colDis: pc.Vec3;

    get shadow(): ObstacleShadow { return this._shadow; }
    private _shadow: ObstacleShadow;

    get animation(): ObstacleAnimation { return this._anim; }
    private _anim: ObstacleAnimation;

    /**
     * (RO) Offset na ose Z od pozice view, kdy dojde k uvolneni prekazky
     */
    get viewDeactOffset(): number { return this._viewDeactOffset; }
    private _viewDeactOffset: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(id: number, modelAssetKey: string, y: number, colAreas: ObstacleCollisionArea[], colDistance: pc.Vec3, shadow?: ObstacleShadow, animation?: ObstacleAnimation, viewDeactOffset: number = 0) {
        this._id = id;
        this._modelAsset = Game.app.assets.find(modelAssetKey, pc.eAssetType.model);
        this._y = y;
        this._colAreas = colAreas;
        this._colDis = colDistance;
        this._shadow = shadow;
        this._anim = animation;
        this._viewDeactOffset = viewDeactOffset;
    }
}